import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import axios from "axios";

const Banner = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/get-slider`)
      .then((res) => setSlides(res.data.sliders))
      .catch((err) => console.error("Error fetching sliders:", err));
  }, []);

  return (
    <>
      {slides.length > 0 && (
        <Box sx={{ width: "100%", height: "90vh" }}>
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            style={{ height: "100%" }}
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {/* Background Image */}
                  <Box
                    sx={{
                      backgroundImage: `url(${
                        process.env.REACT_APP_API_URL
                      }/${slide.image_url.replace(/\\/g, "/")})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      height: "100%",
                      width: "100%",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 1,
                    }}
                  />

                  {/* Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.4)", // adjust opacity as needed
                      zIndex: 2,
                    }}
                  />

                  {/* Content */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 3,
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                      textShadow: "2px 2px 5px rgba(0,0,0,0.7)",
                      p: 2,
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{ fontWeight: "bold", mb: 1, textAlign: "center" }}
                    >
                      {slide.title}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ maxWidth: "800px", textAlign: "center" }}
                    >
                      {slide.subtitle}
                    </Typography>
                  </Box>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      )}

     
    </>
  );
};

export default Banner;
